import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import BadgeComponent from './Badge.component';

export interface NotAssignProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  mode?: 'text' | 'badge';
  has: boolean;
}

const StyledNotAssignText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.LABEL};
`;
const StyledNotAssign = styled.div``;

const NotAssignComponent = ({
  mode = 'text',
  has,
  children,
}: NotAssignProps) => {
  const { t } = useTranslation();

  return (
    <StyledNotAssign>
      {has ? (
        children
      ) : mode === 'text' ? (
        <StyledNotAssignText>{t('Not assign')}</StyledNotAssignText>
      ) : (
        <BadgeComponent appearance="warning" text="Not assign" />
      )}
    </StyledNotAssign>
  );
};

export default NotAssignComponent;
